<template>
  <div class="classroom">
    <div class="classroom-top">
      <div class="classroom-count-container">
        <!-- 搜索框 -->
        <search :placeholder="placeholder" @search="search" />
        <!-- <div class="classroom-count-narration">
          当前课室数量：<span class="classroom-count">{{ total }}</span>
        </div> -->
      </div>
      <div class="classroom-operation-part-container">
        <button class="button add" @click="addClick" v-hasPermi="'sc:classroom:add'">
          <i class="iconfont icon-add" />添加课室
        </button>
        <button class="button delete" @click="deleteClick" v-hasPermi="'sc:classroom:delete'">
          <i class="iconfont icon-delete" />批量删除
        </button>
      </div>
    </div>
    <!-- 课室列表 -->
    <classroomList class="classroom-list" :classroomList="classroomList" @multipleDelete="multipleDelete"
      v-bitmap="getClassroomResult" />
    <!-- 添加课室弹出框 -->
    <classroomAdd :dialogVisible.sync="addShow" v-show="addShow" />
    <!-- 分页 -->
    <div class="classroom-pagination">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageSize)" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange" />
    </div>
  </div>
</template>

<script>
import classroomList from "./components/classroom-list/classroom-list.vue";
import pagination from "@/components/pagination/pagination";
import classroomAdd from "./components/classroom-add/classroom-add.vue";
import search from "@/components/search/search.vue";

export default {
  name: "",
  data() {
    return {
      getClassroomResult: "nullData",
      loading: false,
      // 分页参数
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      classroomList: [],
      addShow: false,
      deleteList: [], // 批量删除列表
      placeholder: "请输入课室名称",
      queryName: "",
    };
  },
  components: {
    classroomList,
    pagination,
    classroomAdd,
    search,
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    // 获取班级考试信息列表
    this.getClassroomList();
  },
  methods: {
    // 刷新
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.classroomList = [];
      this.getClassroomList();
    },
    search(query) {
      this.queryName = query;
      // 刷新
      this.refresh();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getClassroomList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getClassroomList();
    },
    //
    getClassroomList() {
      // this.getClassroomResult = "loading";
      this.get(this.$url.getClassroomList, {
        schoolId: this.user.schoolId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        classroomName: this.queryName,
      })
        .then((res) => {
          // console.log(res);
          if (res.code != 200) {
            return (this.getClassroomResult = "error");
          }
          let data = res;
          this.total = data.total;
          this.total > 0
            ? (this.getClassroomResult = "success")
            : (this.getClassroomResult = "nullData");
          if (this.total === 0) {
            this.$message.warning("暂未设置课室，请添加课室");
          }
          this.classroomList = data.rows;
          // 课室字符串转换为数组
          // this.classroomList.map((item) => {
          //   item.beaconCodeList = item.beaconCode.split(",");
          // });
        })
        .catch((err) => {
          this.getClassroomResult = "error";
          this.$message.error("获取课室失败，请稍后再试");
        });
    },

    addClick(item) {
      // console.log(item);
      // this.classroomInfo = item;
      this.addShow = true;
    },
    multipleDelete(res) {
      this.deleteList = res;
    },
    // 批量删除
    deleteClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要删除的课室");
      }
      this.$confirm(
        "删除课室可能会影响到已编辑的课程表，是否确定删除选中的课室?",
        "删除课室",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          confirmButtonClass: "confirm",
        }
      )
        .then(() => {
          // console.log("this.deleteList=>", this.deleteList);
          // 调用删除接口
          this.delete(this.$url.deleteClassroom, this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./classroom.scss";
</style>
